import React from "react";

const StatusBadge = ({ status, className = "" }) => {
  const getStatusColor = (status) => {
    const colors = {
      open: "badge-info", // Blue
      "customer-replied": "badge-warning", // Orange
      answered: "badge-success", // Green
      closed: "bg-gray-800 text-white dark:bg-gray-700", // Dark gray
    };

    return colors[status] || "badge-default";
  };

  const normalizedStatus = status?.toLowerCase().replace("_", "-") || "";
  const displayText = normalizedStatus.replace("-", " ");

  return (
    <span className={`badge ${getStatusColor(normalizedStatus)} ${className}`}>
      {displayText}
    </span>
  );
};

export default StatusBadge;
